import { render, staticRenderFns } from "./CommercialTranslationDetailFormDialog.vue?vue&type=template&id=6d8fe498&"
import script from "./CommercialTranslationDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./CommercialTranslationDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports